import { TextField, styled } from '@mui/material';
import { PinnacleSearchFieldProps } from './PinnacleSearchField.types';

const StyledSearchField = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'invalidEmail'
})<PinnacleSearchFieldProps>(({ theme, invalidEmail, variant }) => ({
  fontSize: '14px !important',

  '& .MuiInputBase-root': {
    color: '#fff'
  },
  '& .MuiInputLabel-root': {
    color: '#A8A8A8',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: '#fff',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#A8A8A8',
    },
    '&:hover fieldset': {
      borderColor: '#A8A8A8',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#A8A8A8',
    },
  },
}));

export default StyledSearchField;
